export const apiBase = 'https://api.snookermate.net';



// WEBPACK FOOTER //
// ./src/config.prod.js